import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2 sm:gap-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Add", -1)

import { PlusOutlined } from '@ant-design/icons-vue';
import { Tooltip, Button, InputSearch } from 'ant-design-vue';
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchTopbar',
  props: {
    searchText: {},
    onAdd: { type: Function },
    onSearch: { type: Function },
    placeholder: {}
  },
  setup(__props: any) {

const props = __props;



watch(props, (value) => (search.value = value.searchText || ''));

const search = ref('');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputSearch), {
      value: search.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
      placeholder: _ctx.placeholder,
      "enter-button": "",
      "allow-clear": "",
      onSearch: _cache[1] || (_cache[1] = () => _ctx.onSearch(search.value)),
      class: "my-1 sm:my-2"
    }, null, 8, ["value", "placeholder"]),
    _createVNode(_unref(Tooltip), { placement: "topRight" }, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Button), {
          class: "rounded-md border-none bg-green-200 hover:bg-green-400 !text-black",
          onClick: _ctx.onAdd
        }, {
          icon: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(PlusOutlined))))
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    })
  ]))
}
}

})